import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  rest_url: string = null;
}
